export default __webpack_public_path__ + "static/media/italy3.381c3be6.png";